<section
  class="footer-toolbar primary-background-gradient flex flex-col items-center"
>
  <section
    *ngIf="!routeState.isErrorRoute()"
    class="links mx-auto flex divide-x leading-none text-white"
  >
    @for (link of (visibleLinks$ | async) ?? links; track link.label) {
      <div class="link">
        <a [routerLink]="link.path" class="px-1 md:px-4">
          {{ link.label }}
        </a>
        @if (link.showCookie) {
          <button
            type="button"
            id="open_preferences_center"
            class="cookie-icon"
            [class.hidden]="!isYourTargetRoute"
            matTooltip="Update cookies preferences"
          >
            <img src="assets/images/icons/cookie.svg" alt="" />
            <span class="sr-only">Update cookie preferences</span>
          </button>
        }
      </div>
    }
  </section>
  <section class="copyright">
    <div class="mx-auto leading-snug text-white">
        <span class="product-name">
          Career Path DECIDE
        </span>
      <span>
          Vantage Point Consulting Inc.
        </span>
    </div>
    <button
      type="button"
      class="link-button mx-auto leading-snug text-white"
      (click)="aboutUs()"
    >
      Copyright © 2017-2026
    </button>
  </section>
  <section class="social">
    <a
      class="mx-auto leading-snug text-white cursor-pointer"
      href="https://vantagepoint-inc.com/" target="_blank" rel="noopener"
    >
      <img src="assets/images/icons/website.svg" alt="" />
      <span class="sr-only">Vantage Point Consulting website (opens in a new tab)</span>
    </a>
    <a
      class="mx-auto leading-snug text-white cursor-pointer"
      href="https://www.linkedin.com/company/vantage-point-inc./" target="_blank" rel="noopener"
    >
      <img src="assets/images/icons/linkedin-brands.svg" alt="" />
      <span class="sr-only">Vantage Point Consulting on LinkedIn (opens in a new tab)</span>
    </a>
    <a
      class="mx-auto leading-snug text-white cursor-pointer"
      href="https://www.youtube.com/channel/UCP3fjEZALc6NNCAKuUemiWw" target="_blank" rel="noopener"
    >
      <img src="assets/images/icons/youtube.svg" alt="" />
      <span class="sr-only">Vantage Point Consulting on YouTube (opens in a new tab)</span>
    </a>
  </section>
</section>
